import styled from '@emotion/styled'

import Image from '@segment/matcha/components/Image'

import twilioSegmentPng2x from './assets/TwilioSegment@2x.png'
import twilioSegmentWebp from './assets/TwilioSegment.webp'
import twilioSegmentWebp2x from './assets/TwilioSegment@2x.webp'

const TwilioSegmentImage = () => {
  return (
    <picture>
      <source type="image/webp" srcSet={`${twilioSegmentWebp}, ${twilioSegmentWebp2x} 2x`} />
      <StyledImage src={twilioSegmentPng2x} alt="Twilio + Segment" width="273" height="80" loading="lazy" />
    </picture>
  )
}

const StyledImage = styled(Image)`
  height: 50px;

  ${({ theme }) => theme.breakpoints.up(`md`)} {
    height: auto;
  }
`

export default TwilioSegmentImage
